var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v16h-16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v16h-16z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.778 9.192-6.364 6.365-1.414-1.415 6.364-6.364-6.364-6.364 1.414-1.414 6.364 6.364 6.364-6.364 1.415 1.414-6.365 6.364 6.364 6.364-1.415 1.415z",
    fill: "#b4b4b4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcn);
export default __webpack_public_path__ + "static/media/close-icn.18d92b4cc9759c5cb3250aa21130e95a.svg";
export { ForwardRef as ReactComponent };